export enum ProvisionState {
    CONFIRMATION = 'CONFIRMATION',
    NOT_APPROVED = 'NOT_APPROVED',
    APPROVED = 'APPROVED',
    PROVISION = 'PROVISION',
    PRE_REQUISITE_FAILURE = 'PRE_REQUISITE_FAILURE',
    BLOCKED_BY_REQUEST = 'BLOCKED_BY_REQUEST'
}
